// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import prgEntity from './entities/prg.json';
import prgMenu from '../pages/prg/menu.json';
import prgFullForm from '../pages/prg/forms/full.json';
import prgContextForm from '../pages/prg/forms/context.json';
import prgMiniForm from '../pages/prg/forms/mini.json';
import prgLookupForm from '../pages/prg/forms/lookup.json';
import prgTableView from '../pages/prg/views/table.json';
import prgStagesView from '../pages/prg/views/stages.json';
import prgCardsView from '../pages/prg/views/cards.json';
import prgInlineView from '../pages/prg/views/inline.json';
import prgBacklogView from '../pages/prg/views/backlog.json';
import prgSplitView from '../pages/prg/views/split.json';
import prgCalendarView from '../pages/prg/views/calendar.json';
import prgDashboardView from '../pages/prg/views/dashboard.json';

/** Тип запису «Розділ» зі сторінками пакета: меню, форми та подання з pages/prg/. */
export const prgDefinition: IRecordTypeDefinition = {
  ...prgEntity,
  views: assembleViewSet({
      table: prgTableView,
      stages: prgStagesView,
      cards: prgCardsView,
      inline: prgInlineView,
      backlog: prgBacklogView,
      split: prgSplitView,
      calendar: prgCalendarView,
      dashboard: prgDashboardView,
  }),
  form: prgFullForm,
  forms: { full: prgFullForm, context: prgContextForm, mini: prgMiniForm, lookup: prgLookupForm },
  menu: prgMenu,
} as IRecordTypeDefinition;
